import { render, staticRenderFns } from "./Location-Details.vue?vue&type=template&id=5e38f978&"
import script from "./Location-Details.vue?vue&type=script&lang=js&"
export * from "./Location-Details.vue?vue&type=script&lang=js&"
import style0 from "./Location-Details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports